import { operationalEvent } from '@atlassian/help-center-common-util/analytics/events';
import { getEnv } from '@atlassian/help-center-common-util/env';

export const fireAnalyticsForEmptyHelpCenterLayoutAri = () => {
	const traceId = getEnv().traceId;
	operationalEvent({
		action: 'emptyHelpCenterLayoutAriReceived',
		actionSubject: 'help-center-layout-ari',
		attributes: {
			traceId,
		},
		source: 'HelpCenter',
	});
};
